import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CaptchaService } from 'app/services/captcha.service';
import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent implements OnInit {

  captcha: string;
  captchaGuid: string;
  imageCaptcha: string;
  base64;
  form: FormGroup;
  loading: boolean = true;
  disabledCaptcha: boolean = false;

  @Input() formDenounceInvalid: boolean;
  @Output() onChangeCaptcha: EventEmitter<boolean> = new EventEmitter();
  @Output() isValidated: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private captchaService: CaptchaService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private toastService: ToastService,
  ) { 
    this.form = this.formBuilder.group({
      captcha: [null, [Validators.required, Validators.minLength(1)]]
    });
  }

  ngOnInit(): void {
    this.captchaGuid = Guid.newGuid();
  }

  ngAfterViewInit(){
    this.getNewCaptcha();
  }

  private getNewCaptcha() {
    this.captchaService.getCaptcha(this.captchaGuid).subscribe(
      res => {
        this.loading = false;
        this.captcha = res.captcha;
        this.imageCaptcha = res.image;
        this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.imageCaptcha);
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  onRefreshCaptcha(){
    this.captchaGuid = Guid.newGuid();
    this.getNewCaptcha();
  }

  onValidateCaptcha(){
    if(this.formDenounceInvalid){
      this.onChangeCaptcha.emit(true);
      return;
    }

    if(this.form.get('captcha').value === this.captcha){
      this.loading = true;
      this.captchaService.validateCaptcha(this.form.get('captcha').value, this.captchaGuid).subscribe(
        res => {
          if(res){
            this.loading = false;
            let msg = this.translate.instant("CAPTCHA.VALIDATED");
            this.toastService.success(msg);
            this.disabledCaptcha = true;
            this.isValidated.emit(true);
          }else{
            this.loading = false;
            let msg = this.translate.instant("CAPTCHA.INVALID_CHARACTERS");
            this.toastService.error(msg);
          }
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      )
    }else{
      let msg = this.translate.instant("CAPTCHA.INVALID_CHARACTERS");
      this.toastService.error(msg);
    }
  }
}
class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

// Example of a bunch of GUIDs
for (var i = 0; i < 20; i++) {
  var id = Guid.newGuid();
  console.log(id);
}
